module.exports = __webpack_public_path__ + "static/img/pros-0.74b8fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pros-0.png
// module id = TjCj
// module chunks = 1